import React from 'react';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import { map } from 'lodash';

import { Icon } from 'components';
import { useToggler } from 'hooks';
import CollapsibleSettingsRow from '../CollapsibleSettingsRow';
import { msgMapping } from './constants';
import useOddFormatSelect from './useOddFormatSelect';

import chevron from 'assets/svg/chevron.svg';
import './oddFormatSelectMobile.scss';

const OddFormatSelectMobile: React.FC = () => {
    const {
        currOddFormat,
        title,
        filteredOddFormats,
        onMouseDown,
    } = useOddFormatSelect();

    const [isOpen, toggleRow] = useToggler(false);

    return (
        <CollapsibleSettingsRow
            isOpen={isOpen}
            onToggle={toggleRow}
            title={title}
            message={msgMapping[currOddFormat]}
        >
            {map(filteredOddFormats, item => (
                <div
                    key={item}
                    data-format={item}
                    styleName={cn('list', {
                        'is-selected': currOddFormat === item,
                    })}
                    onMouseDown={onMouseDown}
                >
                    {currOddFormat === item && (
                        <Icon styleName="icon" glyph={chevron} />
                    )}
                    <div styleName="option-title">
                        <FormattedMessage {...msgMapping[item]} />
                    </div>
                </div>
            ))}
        </CollapsibleSettingsRow>
    );
};

export default OddFormatSelectMobile;
